export default "__VITE_ASSET__Bd$6xcgz__"